// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const CalendarSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.white}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      width="35"
      height="38"
      viewBox="0 0 35 38"
      xmlns="http://www.w3.org/2000/svg"
      fill="#FCFBFC"
      role="presentation"
    >
      <g fillRule="evenodd">
        <path d="M4.096 4C1.846 4 0 5.865 0 8.138v25.724C0 36.135 1.845 38 4.096 38h26.808C33.154 38 35 36.135 35 33.862V8.138C35 5.865 33.155 4 30.904 4H4.096zm.753 3h25.3C31.19 7 32 7.77 32 8.764V14H3V8.764C3 7.77 3.806 7 4.85 7zM3 17h29v16.163C32 34.198 31.192 35 30.15 35H4.85C3.805 35 3 34.198 3 33.163V17z" />
        <rect x="7" width="4" height="12" rx="4.268" />
        <rect x="25" width="4" height="12" rx="4.268" />
        <rect x="6" y="24" width="4" height="4" rx="2.561" />
        <rect x="6" y="29" width="4" height="4" rx="2.561" />
        <rect x="12" y="19" width="4" height="4" rx="2.561" />
        <rect x="12" y="24" width="4" height="4" rx="2.561" />
        <rect x="12" y="29" width="4" height="4" rx="2.561" />
        <rect x="18" y="19" width="4" height="4" rx="2.561" />
        <rect x="18" y="24" width="4" height="4" rx="2.561" />
        <rect x="18" y="29" width="4" height="4" rx="2.561" />
        <rect x="24" y="19" width="4" height="4" rx="2.561" />
        <rect x="24" y="24" width="4" height="4" rx="2.561" />
      </g>
    </svg>
  </SvgContainer>
);
CalendarSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default CalendarSvg;
